// extracted by mini-css-extract-plugin
export default {"container":"ResultsPerPage_container__tYwuy","label":"ResultsPerPage_label__cAeyE","select":"ResultsPerPage_select__rjQFq","selectDisabled":"ResultsPerPage_selectDisabled__FeBQe"};